module.exports = __webpack_public_path__ + "img/SB_17.ac3c841a.png";